import { toast } from "react-toastify";
import axios from "axios";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import DefaultModalLayout, {
  ModalFixedBox,
} from "../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import styled from "styled-components";
import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";
import dayjs from "dayjs";
import Blank from "../../../DefaultStyles/Blank";
import { Input } from "../../../Input/Input";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalRowContentContainer } from "../../AlimTalk/AlimTalkModal";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import { getSubscriptionNameV3 } from "../../../../ApiTS/ServiceDatasTS_V3";
import { getStateStr } from "../../../../pages/Party/Lingokids";
import { getYTStateString } from "../../../../pages/Party/YoutubeMatchingInfo";
import CalendarModalBtn from "../../../Button/CalendarModalBtn";
import RadioBtn from "../../../Button/RadioBtn";
import {
  createYoutubeCommentPreset,
  getYoutubeSubscriptionPeriod,
  YoutubeCommentPreset,
  YoutubeIssuanceType,
} from "./youtubeCommentPreset";
import {
  hasYoutubeRoundChanges,
  saveYoutubeExtrainfo,
  saveYoutubeUrlAllocation,
} from "./youtubeExtrainfoApi";

const ROUND_STATUS_LABELS: Record<number, string> = {
  1: "대기",
  2: "할당 완료",
  3: "활성화 완료",
};

const getRoundStatusLabel = (status: number) =>
  ROUND_STATUS_LABELS[status] ?? `${status}`;

const normalizeRound = (value: unknown) => {
  const round = Number(value);
  return Number.isInteger(round) && round >= 1 && round <= 12 ? round : 1;
};

const normalizeRoundStatus = (value: unknown) => {
  const status = Number(value);
  return Number.isInteger(status) && status >= 1 ? status : 1;
};

interface YoutubeUpdateModalProps extends DefaultModalCommonProps {
  uid: number;
  partyid: number;
  ytstate: number;
  servsubsid: number;
  dueDate?: string;
  ytRound?: number | string | null;
  ytRoundStatus?: number | string | null;
  ytRoundEmail?: string | null;
  ytRoundLink?: string | null;
  onAllocationSaved: (preset: YoutubeCommentPreset) => void;
  confirmEvent: () => void;
  closeEvent: () => void;
  enddate?: string;
}

export default function YoutubeUpdateModal({
  closeEvent,
  confirmEvent,
  partyid,
  ytstate,
  uid,
  servsubsid,
  dueDate,
  enddate,
  ytRound,
  ytRoundStatus,
  ytRoundEmail,
  ytRoundLink,
  onAllocationSaved,
}: YoutubeUpdateModalProps) {
  const auth = useRecoilValue(authType);
  const [updateBtnClick, setUpdateBtnClick] = useState(false);
  const [pendingAllocation, setPendingAllocation] = useState<{
    request: {
      pid: string;
      uid: string;
      email: string;
      round: number;
      r_status: number;
      r_link: string;
    };
    result: { email: string; round: number; r_status: number; r_link: string };
  } | null>(null);
  const initialRound = normalizeRound(ytRound);
  const initialRoundStatus = normalizeRoundStatus(ytRoundStatus);
  const initialRoundAccount = ytRoundEmail ?? "";
  const initialRoundLink = ytRoundLink ?? "";
  const [roundAccount, setRoundAccount] = useState(initialRoundAccount);
  const [roundLink, setRoundLink] = useState(initialRoundLink);
  const [issuanceType, setIssuanceType] = useState<YoutubeIssuanceType>(
    initialRound === 1 ? "new" : "reissue",
  );
  const [roundStartDate, setRoundStartDate] = useState(() =>
    dayjs().format("YYYY-MM-DD"),
  );
  const [selectedRound, setSelectedRound] = useState<OptionType>({
    value: String(initialRound),
    label: `${initialRound}회차`,
  });
  const [selectedRoundStatus, setSelectedRoundStatus] = useState<OptionType>({
    value: String(initialRoundStatus),
    label: getRoundStatusLabel(initialRoundStatus),
  });
  const [savedValues, setSavedValues] = useState({
    partyid: String(partyid),
    ytstate: String(ytstate),
    dueDate: dueDate || "",
    round: String(initialRound),
    roundStatus: String(initialRoundStatus),
    roundAccount: initialRoundAccount,
    roundLink: initialRoundLink,
  });
  const currentRound = Number(savedValues.round);
  const roundOptions: OptionType[] = Array.from({ length: 12 }, (_, index) => {
    const round = index + 1;
    return {
      value: String(round),
      label: `${round}회차${round === currentRound ? " (현재)" : ""}`,
      isDisabled: round < currentRound,
    };
  });
  const currentRoundStatus = Number(savedValues.roundStatus);
  const roundStatusOptions: OptionType[] = Object.entries(
    ROUND_STATUS_LABELS,
  ).map(([value, label]) => ({
    value,
    label: `${label}${Number(value) === currentRoundStatus ? " (현재)" : ""}`,
  }));
  if (!(savedValues.roundStatus in ROUND_STATUS_LABELS)) {
    roundStatusOptions.push({
      value: savedValues.roundStatus,
      label: `${getRoundStatusLabel(currentRoundStatus)} (현재)`,
    });
  }

  const savedYtstate = Number(savedValues.ytstate);

  const options: OptionType[] = [
    // {
    //   value: "1",
    //   label: getYTStateString(1),
    //   isDisabled: ytstate >2  ? true : false,
    // },
    // 접수중
    {
      value: "2",
      label: getYTStateString(2),
      // 접수중이나 처리완료는 수정 불가능
      isDisabled: savedYtstate === 2 ? true : false,
    },
    // 처리완료
    {
      value: "3",
      label: getYTStateString(3),
      // 접수중이 아니면 불가능
      isDisabled: savedYtstate !== 2 ? true : false,
    },
    // // 계정정보 수정 필요
    // {
    //   value: "4",
    //   label: getYTStateString(4),
    //   // 예정이거나 계정정보 수정 필요면 불가능
    //   isDisabled: ytstate !== 2 ? true : false,
    // },
    // // 백업코드 수정 필요
    // {
    //   value: "5",
    //   label: getYTStateString(5),
    //   // 예정이거나 백업코드 수정필요면 불가능
    //   isDisabled: ytstate !== 2 ? true : false,
    // },
    // 보류 (추후 처리)
    {
      value: "7",
      label: getYTStateString(7),
      // 예정이거나 보류중이면 불가능
      isDisabled: savedYtstate !== 2 ? true : false,
    },
  ];

  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: String(ytstate),
    label: getYTStateString(ytstate),
  });

  interface Party {
    servsubsid: number;
    partyid: string;
    grade: number;
    // add other properties if needed
  }
  const [PartyList, setPartyList] = useState<Party[]>([]);
  const [SelectedParty, setSelectedParty] = useState<OptionType>({
    value: String(partyid) ?? "",
    label: partyid !== 0 ? String(partyid) : "선택",
  });

  const [selectedDueDate, setSelectedDueDate] = useState<string>(dueDate || "");

  // const {
  //   response: partyListResponse,
  //   error: partyListError,
  //   loading: partyListLoading,
  // } = useApi({
  //   method: "get",
  //   url: `party?servsubsid=${servsubsid}&state=1&page=0&size=100`,
  // });

  const isPartyChanged = SelectedParty?.value !== savedValues.partyid;
  const isYtstateChanged = dropDownValue?.value !== savedValues.ytstate;
  const isDueDateChanged = selectedDueDate !== savedValues.dueDate;
  const isCompleted = dropDownValue?.value === "3";
  const shouldSaveRound =
    isCompleted &&
    hasYoutubeRoundChanges(
      {
        round: savedValues.round,
        status: savedValues.roundStatus,
        email: savedValues.roundAccount,
        link: savedValues.roundLink,
      },
      {
        round: selectedRound.value ?? "",
        status: selectedRoundStatus.value ?? "",
        email: roundAccount,
        link: roundLink,
      },
    );
  const hasChanges =
    isPartyChanged || isYtstateChanged || isDueDateChanged || shouldSaveRound;
  const shouldHandleAllocation =
    isCompleted &&
    selectedRoundStatus.value === "2" &&
    (shouldSaveRound || isYtstateChanged);
  const shouldSaveYtp = shouldSaveRound || shouldHandleAllocation;

  const isDueDateRequired =
    dropDownValue?.value === "7" || dropDownValue?.value === "3";

  const handleConfirm = async () => {
    if (!hasChanges || updateBtnClick) {
      return;
    }

    if (isDueDateRequired && !selectedDueDate) {
      toast.error("목표일을 선택하세요");
      return;
    }
    if (shouldHandleAllocation) {
      if (!roundAccount.trim()) {
        toast.error("회차계정을 입력하세요");
        return;
      }
      if (issuanceType === "reissue" && !roundStartDate) {
        toast.error("회차 시작일을 선택하세요");
        return;
      }
    }
    setUpdateBtnClick(true);
    try {
      let savedRound = Number(selectedRound.value);
      let savedRoundStatus = Number(selectedRoundStatus.value);
      let savedAccount = roundAccount;
      let savedLink = roundLink;
      let roundResult: { round: number; r_status: number } | undefined;
      if (shouldSaveYtp) {
        const request = {
          pid: String(SelectedParty.value),
          uid: String(uid),
          email: roundAccount.trim(),
          round: savedRound,
          r_status: Number(selectedRoundStatus.value),
          r_link: roundLink.trim(),
        };
        const allocation =
          pendingAllocation &&
          pendingAllocation.request.pid === request.pid &&
          pendingAllocation.request.uid === request.uid &&
          pendingAllocation.request.email === request.email &&
          pendingAllocation.request.round === request.round &&
          pendingAllocation.request.r_status === request.r_status &&
          pendingAllocation.request.r_link === request.r_link
            ? pendingAllocation.result
            : await saveYoutubeUrlAllocation(request);
        setPendingAllocation({ request, result: allocation });
        savedRound = allocation.round;
        savedRoundStatus = allocation.r_status;
        savedAccount = allocation.email;
        savedLink = allocation.r_link;
        roundResult = allocation;
      }

      if (
        isPartyChanged ||
        isYtstateChanged ||
        isDueDateChanged ||
        shouldSaveYtp
      ) {
        await axios.post("/api/proxyparty", {
          uid,
          partyid: Number(SelectedParty.value),
          ytstate: Number(dropDownValue.value),
          ...(isDueDateChanged && { duedate: selectedDueDate }),
          round: savedRound,
          r_status: savedRoundStatus,
        });
      }

      await saveYoutubeExtrainfo({
        partyid: Number(SelectedParty.value),
        uid,
        roundResult,
        ...(shouldHandleAllocation &&
          savedRoundStatus === 2 && {
            ytstate: Number(dropDownValue.value),
            duedate: selectedDueDate,
          }),
      });

      toast.success("변경하였습니다.");
      setPendingAllocation(null);
      setSelectedRound({
        value: String(savedRound),
        label: `${savedRound}회차`,
      });
      setSelectedRoundStatus({
        value: String(savedRoundStatus),
        label: getRoundStatusLabel(savedRoundStatus),
      });
      setRoundAccount(savedAccount);
      setRoundLink(savedLink);
      setSavedValues({
        partyid: SelectedParty.value ?? "",
        ytstate: dropDownValue.value ?? "",
        dueDate: selectedDueDate,
        round: String(savedRound),
        roundStatus: String(savedRoundStatus),
        roundAccount: savedAccount,
        roundLink: savedLink,
      });
      confirmEvent();
      if (shouldHandleAllocation && savedRoundStatus === 2) {
        onAllocationSaved(
          createYoutubeCommentPreset({
            issuanceType,
            round: savedRound,
            subscriptionPeriod: getYoutubeSubscriptionPeriod(servsubsid),
            account: savedAccount,
            roundStartDate,
          }),
        );
      }
    } catch (error) {
      const message = axios.isAxiosError(error)
        ? (error.response?.data?.message ?? error.response?.data?.data)
        : error instanceof Error
          ? error.message
          : undefined;
      toast.error(
        typeof message === "string" ? message : "변경사항 저장에 실패했습니다.",
      );
    } finally {
      setUpdateBtnClick(false);
    }
  };

  //   파티 리스트 받아오기
  // useEffect(() => {
  //   if (
  //     partyListResponse?.status === 200 ||
  //     partyListResponse?.status === 201
  //   ) {
  //     setPartyList(partyListResponse?.data?.items);
  //     //   toast.success("파티 리스트 받아오기 완료.");
  //   }
  // }, [partyListResponse]);

  console.log(uid, SelectedParty.value, dropDownValue.value);

  return (
    <>
      <DefaultModalLayout
        modalTitle="유튜브 상태 수정"
        closeEvent={() => closeEvent()}
        confirmEvent={handleConfirm}
        isLargeModal={true}
        confirmDisabled={
          !hasChanges ||
          updateBtnClick ||
          dropDownValue?.label === "선택" ||
          SelectedParty?.label === "선택"
        }
      >
        <ModalRow>
          <ModalLabel>파티 ID</ModalLabel>
          <ModalRowContentContainer>
            {partyid !== 0 ? (
              <ModalFixedBox>{partyid}</ModalFixedBox>
            ) : (
              <DropDown
                dropdownValue={SelectedParty}
                setDropDownValue={setSelectedParty}
                optionList={PartyList.map((party) => ({
                  value: String(party.partyid),
                  label: `${String(party.partyid)}`,
                }))}
                // boxWidth={0}
              />
            )}
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow>
          <ModalLabel>상태</ModalLabel>

          <ModalRowContentContainer>
            <DropDown
              isDisabled={false}
              setDropDownValue={setDropDownValue}
              dropdownValue={dropDownValue}
              optionList={options}
              // boxWidth={180}
            />
          </ModalRowContentContainer>
        </ModalRow>

        {dropDownValue?.value === "7" || dropDownValue?.value === "3" ? (
          <ModalRow>
            <ModalLabel>목표일</ModalLabel>
            <ModalRowContentContainer>
              <DueDateContainer>
                <CalendarModalBtn
                  calendar={{
                    value: selectedDueDate
                      ? dayjs(selectedDueDate).format("YYYY-MM-DD")
                      : "",
                    initValue: "날짜 선택",
                  }}
                  modal={{
                    dateValue: selectedDueDate,
                    changeEvent: (date: string) => setSelectedDueDate(date),
                    maxDate: enddate,
                  }}
                />
                {dropDownValue?.value === "3" && (
                  <QuickDateButtonContainer>
                    <QuickDateButton
                      onClick={() =>
                        setSelectedDueDate(
                          dayjs().add(3, "month").format("YYYY-MM-DD"),
                        )
                      }
                    >
                      3개월 후
                    </QuickDateButton>
                    <QuickDateButton
                      onClick={() => enddate && setSelectedDueDate(enddate)}
                      disabled={!enddate}
                    >
                      종료일까지
                    </QuickDateButton>
                  </QuickDateButtonContainer>
                )}
              </DueDateContainer>
            </ModalRowContentContainer>
          </ModalRow>
        ) : (
          <></>
        )}

        {isCompleted ? (
          <>
            <ModalRow>
              <ModalLabel>회차</ModalLabel>
              <ModalRowContentContainer>
                <DropDown
                  dropdownValue={roundOptions.find(
                    (option) => option.value === selectedRound.value,
                  )}
                  setDropDownValue={(option: OptionType) => {
                    const isCurrentRound = option.value === savedValues.round;
                    const roundStatus = isCurrentRound
                      ? savedValues.roundStatus
                      : "1";
                    setSelectedRound(option);
                    setSelectedRoundStatus({
                      value: roundStatus,
                      label: getRoundStatusLabel(Number(roundStatus)),
                    });
                    setRoundLink(isCurrentRound ? savedValues.roundLink : "");
                    setIssuanceType(
                      Number(option.value) === 1 ? "new" : "reissue",
                    );
                  }}
                  optionList={roundOptions}
                />
              </ModalRowContentContainer>
            </ModalRow>
            <ModalRow>
              <ModalLabel>회차상태</ModalLabel>
              <ModalRowContentContainer>
                <DropDown
                  dropdownValue={roundStatusOptions.find(
                    (option) => option.value === selectedRoundStatus.value,
                  )}
                  setDropDownValue={setSelectedRoundStatus}
                  optionList={roundStatusOptions}
                />
              </ModalRowContentContainer>
            </ModalRow>
            <ModalRow>
              <ModalLabel>회차계정</ModalLabel>
              <ModalRowContentContainer>
                <Input
                  value={roundAccount}
                  onChange={(event) => setRoundAccount(event.target.value)}
                  placeholder="계정명을 입력하세요"
                />
              </ModalRowContentContainer>
            </ModalRow>
            <ModalRow>
              <ModalLabel>회차링크</ModalLabel>
              <ModalRowContentContainer>
                <Input
                  value={roundLink}
                  onChange={(event) => setRoundLink(event.target.value)}
                  placeholder="링크를 입력하세요"
                />
              </ModalRowContentContainer>
            </ModalRow>
            {selectedRoundStatus.value === "2" ? (
              <>
                <ModalRow>
                  <ModalLabel>발급 구분</ModalLabel>
                  <ModalRowContentContainer
                    style={{ display: "flex", gap: 24 }}
                  >
                    <RadioBtn
                      label="신규발급"
                      check={issuanceType === "new"}
                      clickEvent={() => setIssuanceType("new")}
                      disabled={selectedRound.value !== "1"}
                      noTooltip
                      sHeight={38}
                    />
                    <RadioBtn
                      label="재발급"
                      check={issuanceType === "reissue"}
                      clickEvent={() => setIssuanceType("reissue")}
                      noTooltip
                      sHeight={38}
                    />
                  </ModalRowContentContainer>
                </ModalRow>
                {issuanceType === "reissue" ? (
                  <ModalRow>
                    <ModalLabel>{selectedRound.value}회차 시작일</ModalLabel>
                    <ModalRowContentContainer>
                      <Input
                        type="date"
                        value={roundStartDate}
                        onChange={(event) =>
                          setRoundStartDate(event.target.value)
                        }
                      />
                    </ModalRowContentContainer>
                  </ModalRow>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}

        <Blank marginHeight={20} blankHeight={20} />
      </DefaultModalLayout>

      {updateBtnClick && <Loader />}
    </>
  );
}

const Column = styled.div`
  width: 250px;
`;

const Row = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
const ValueContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DueDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const QuickDateButtonContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const QuickDateButton = styled.button`
  padding: 6px 12px;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  color: #505050;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }

  &:disabled {
    color: #d3d3d3;
    cursor: not-allowed;

    &:hover {
      background-color: #ffffff;
    }
  }
`;
